import Stack from './stack';
import Card from './card';

global.gajus = global.gajus || {};

global.gajus.Swing = {
    Stack,
    Card
};

export {
    Stack,
    Card
};



/** WEBPACK FOOTER **
 ** ./index.js
 **/